import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Paquete } from 'app/models/paquete-model';
import { Services } from 'app/servicios.service';
import { mergeScan } from 'rxjs-compat/operator/mergeScan';

@Component({
  selector: 'app-aereo',
  templateUrl: './aereo.component.html',
  styleUrls: ['./aereo.component.css']
})
export class AereoComponent implements OnInit {
  public paquetes: Array<Paquete> = new Array<Paquete>();
  loading = false;
  constructor(private API: Services) { }

  ngOnInit(): void {
    this.loadExternalScript('//agenciasat.aereos.app/aereos.app.min.js');
    this.API.getPaquetesDestacados().subscribe(data => {
      this.paquetes = data;
      this.loading = false;
    });
  }

  /*resizeIframe(obj){
    console.log('Entra');
    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  }*/
  public loadExternalScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }

}
